import { HEX_COLOR_FORMAT, RGBA_COLOR_FORMAT } from "../../constants.ts";
import type { ColorFormat } from "../../types.ts";

export const ColorFormatDisplay: Record<ColorFormat, string> = {
  [HEX_COLOR_FORMAT]: "HEX",
  [RGBA_COLOR_FORMAT]: "RGBA",
};
